import apiClient from './apiClient';

const normalizeTicket = (t) => ({ ...t, priority: t.priority?.toLowerCase(), status: t.status?.toLowerCase(), source: t.source?.toLowerCase(), assignedTo: t.assignedTo ?? t.assignedToUserId });
const toTicketPayload = (p) => ({ ...p, priority: p.priority?.toUpperCase(), status: p.status?.toUpperCase(), source: p.source?.toUpperCase() });

export async function fetchTickets() {
  const { data } = await apiClient.get('/tickets');
  return data.map(normalizeTicket);
}


export async function raiseTicket(payload) {
  const { data } = await apiClient.post('/tickets', toTicketPayload(payload));
  return normalizeTicket(data);
}

export async function patchTicket(id, changes) {
  const { data } = await apiClient.patch(`/tickets/${id}`, toTicketPayload(changes));
  return normalizeTicket(data);
}
